export * from './types';
export var createChatbotPocApi = function (baseUrl, http) {
    var answersOrigin;
    try {
        var origin_1 = new URL(baseUrl).origin;
        answersOrigin = origin_1;
    }
    catch (_a) {
        answersOrigin = '';
    }
    var apiUrl = answersOrigin + "/apps/chatbot";
    return {
        getFlows: function () {
            return http.get(apiUrl + "/flows");
        },
        createFlow: function (name) {
            return http.post(apiUrl + "/flows", { name: name });
        },
        updateFlow: function (flow) {
            return http.put(apiUrl + "/flows/" + flow.id, flow);
        },
        removeFlow: function (flowId) {
            return http.delete(apiUrl + "/flows/" + flowId);
        },
        getWidgetDefaultFlow: function (widgetId) {
            return http.get(apiUrl + "/widgets/" + widgetId + "/default");
        },
        setWidgetDefaultFlow: function (widgetId, flowId) {
            return http.put(apiUrl + "/widgets/" + widgetId + "/default", { flowId: flowId });
        },
    };
};
//# sourceMappingURL=index.js.map